// extracted by mini-css-extract-plugin
export default {"readersModeContent":"ReaderModeContent_readersModeContent__rz8qw","pageNumber":"ReaderModeContent_pageNumber__f+vb3"};